module.exports = __webpack_public_path__ + "static/media/freecodecamp_logo.d1c23cc9.svg";